import { isNumber } from '../utils.js';
import { getCoefficient } from './helpers.js';

function normalizeResizeDirections(state, directions) {
    var coefficient = getCoefficient(state);
    return {
        left: 'left' in directions ? directions.left * coefficient : 0,
        top: 'top' in directions ? directions.top * coefficient : 0,
        right: 'right' in directions ? directions.right * coefficient : 0,
        bottom: 'bottom' in directions ? directions.bottom * coefficient : 0,
    };
}
function normalizeCenter(state, center) {
    var coefficient = getCoefficient(state);
    return {
        left: center.left * coefficient + state.visibleArea.left,
        top: center.top * coefficient + state.visibleArea.top,
    };
}
function fillMoveDirections(directions) {
    return {
        left: 'left' in directions ? directions.left : 0,
        top: 'top' in directions ? directions.top : 0,
    };
}
function fillResizeDirections(directions) {
    return {
        left: 'left' in directions ? directions.left : 0,
        top: 'top' in directions ? directions.top : 0,
        right: 'right' in directions ? directions.right : 0,
        bottom: 'bottom' in directions ? directions.bottom : 0,
    };
}
function normalizeMoveDirections(state, directions) {
    var coefficient = getCoefficient(state);
    return {
        left: 'left' in directions ? directions.left * coefficient : 0,
        top: 'top' in directions ? directions.top * coefficient : 0,
    };
}
function normalizeImageTransform(state, transform) {
    if (transform.scale) {
        transform.scale = {
            factor: isNumber(transform.scale) ? transform.scale : transform.scale.factor,
            center: !isNumber(transform.scale) && transform.scale.center
                ? normalizeCenter(state, transform.scale.center)
                : undefined,
        };
    }
    if (transform.rotate) {
        transform.rotate = {
            angle: isNumber(transform.rotate) ? transform.rotate : transform.rotate.angle,
            center: !isNumber(transform.rotate) && transform.rotate.center
                ? normalizeCenter(state, transform.rotate.center)
                : undefined,
        };
    }
    if (transform.move) {
        transform.move = normalizeMoveDirections(state, transform.move);
    }
    return transform;
}

export { fillMoveDirections, fillResizeDirections, normalizeCenter, normalizeImageTransform, normalizeMoveDirections, normalizeResizeDirections };
